import { push, replace } from 'connected-react-router';
import { stringifyUrl } from 'query-string';
import { Dispatch } from 'redux';
import { StandardQueryParams } from '../../global/types';
import { ORDERS_URL } from '../../global/urls';
import { defaultSortOrder } from './constants';

type QueryParams = StandardQueryParams;

export const getOrdersUrl = (params: QueryParams): string => {
  const query: QueryParams = {};
  if (params.search) {
    query.search = params.search;
  }
  if (params.sort && params.sort !== defaultSortOrder) {
    query.sort = params.sort;
  }
  if (params.start) {
    query.start = params.start;
  }
  return stringifyUrl({ url: ORDERS_URL, query });
};

export const replaceOrdersUrl = (dispatch: Dispatch, params: QueryParams): void => {
  const url = getOrdersUrl(params);
  dispatch(replace(url, { keepState: true }));
};

export const pushOrdersUrl = (dispatch: Dispatch, params: QueryParams, keepState = false): void => {
  const url = getOrdersUrl(params);
  dispatch(push(url, { keepState }));
};
